unable to read source [project]/packages/src/components/base/progress/Progress.tsx